import Marquee from "react-fast-marquee";
import { LOGO_DIAMOND } from "@/lib/site";

const CLIENTS = [
  "IMPLANTOLOŠKI CENTAR SMILE",
  "ORDINACIJA NELA SABO KOPIĆ",
  "OPTIKA LAPIĆ",
  "PHYSIO KOLAR",
  "SUBLIPRINT",
];

export default function ClientMarquee() {
  return (
    <section className="relative z-10 border-y border-[#222] bg-[#0a0a0a] py-10">
      <p className="mb-8 text-center font-display text-xs font-bold uppercase tracking-[0.24em] text-white/40">
        Klijenti koji nam vjeruju
      </p>
      <Marquee speed={40} gradient gradientColor="#0a0a0a" gradientWidth={120} autoFill>
        {CLIENTS.map((c, i) => (
          <span key={i} className="mx-8 flex items-center gap-6 font-display text-2xl font-extrabold uppercase tracking-tight text-white/25 md:text-4xl">
            {c}
            <img src={LOGO_DIAMOND} alt="" className="h-5 w-5 object-contain opacity-40" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
